// component
import { mdiFinance, mdiFormatListBulleted, mdiHistory, mdiHomeAnalytics } from '@mdi/js';
import Icon from '@mdi/react';
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'Alfanumérico',
    path: '/dashboard/app',
    icon: <Icon path={mdiFinance} size={1} />,
  },
  {
    title: 'Histórico',
    path: '/dashboard/history',
    icon: <Icon path={mdiHistory} size={1} />,
  },
  // {
  //   title: 'product',
  //   path: '/dashboard/products',
  //   icon: icon('ic_cart'),
  // },
  // {
  //   title: 'blog',
  //   path: '/dashboard/blog',
  //   icon: icon('ic_blog'),
  // },
  // {
  //   title: 'login',
  //   path: '/login',
  //   icon: icon('ic_lock'),
  // },
  // {
  //   title: 'Not found',
  //   path: '/404',
  //   icon: icon('ic_disabled'),
  // },
];

export default navConfig;
